<template>
	<div class="grid grid-cols-1" :style="cssVariables">
		<div class="col-span-1 px-1 sm:px-8 md:px-24 lg:px-10 py-4 callout-wrapper">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'callout-section',
	props: {
		bgColor: String,
		textColor: {
			type: String,
			default: '#fff'
		},
		textAlign: {
			type: String,
			default: 'center'
		}
	},
	computed: {
		cssVariables() {
			return {
				'--bg-color': this.bgColor,
				'--text-color': this.textColor,
				'--text-align': this.textAlign
			}
		}
	}
}
</script>

<style lang="postcss" scoped>
	.callout-wrapper {
		max-height: 125px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 1.125rem;
		font-family: theme('fontFamily.arial-bold');
		text-align: var(--text-align);
		color: var(--text-color);
		background-color: var(--bg-color);
	}
	@media screen and (min-width: 769px) {
		.callout-wrapper {
			font-size: 1.875rem;
		}
	}
</style>